// comma
const common = {

  comma: (str) => {
    return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
    
  //문자가 날짜형이 맞는지 체크 20180101
  isDate: (txtDate) => {
      let currVal = txtDate;
      if (currVal == '')
          return false;

      let rxDatePattern = /^(\d{4})(\d{1,2})(\d{1,2})$/;
      let dtArray = currVal.match(rxDatePattern);

      if (dtArray == null)
          return false;

      let dtYear = dtArray[1];
      let dtMonth = dtArray[2];
      let dtDay = dtArray[3];

      if (dtMonth < 1 || dtMonth > 12)
          return false;
      else if (dtDay < 1 || dtDay > 31)
          return false;
      else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31)
          return false;
      else if (dtMonth == 2) {
          let isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0));
          if (dtDay > 29 || (dtDay == 29 && !isleap))
            return false;
      }
      return true;
    }
}

export {common}